export const supportedFrameRates = [30, 15, 7, 1] as const;
